const AUTHENTICATION_ERROR_PATTERNS = [
  /It looks like Buffer has lost the authorization/i,
  /Yoiks! It looks like Buffer has lost authorization to post on your behalf\. No need to worry, though! Visit your channel on Buffer\.com and select the "Manage Channels" option to refresh your connection/i,
  /could not authenticate/i,
  /\[unauthorized\]/i,
  /Invalid or expired token/i,
  /Invalid Credentials/i,
  /Could not authenticate you/i,
  /Authorization failed/i,
  /Error invalidating access token/i,
  /The access token was invalidated on the device/i,
  /The access token was revoked/i,
  /Unable to verify access token/i,
  /tampered token/i,
  /Could not json decode the token/i,
  /Bad Authentication data/i,
]

export function isAuthenticationError(
  errorMessage: string | null | undefined,
): boolean {
  if (!errorMessage) return false

  return AUTHENTICATION_ERROR_PATTERNS.some((pattern) =>
    pattern.test(errorMessage),
  )
}

export function shouldShowReconnectedMessage(
  errorMessage: string | null | undefined,
  isChannelDisconnected: boolean,
): boolean {
  return isAuthenticationError(errorMessage) && !isChannelDisconnected
}

export const RECONNECTED_CHANNEL_MESSAGE =
  "This failed to post at the scheduled time due to the channel being disconnected. Now that it's been reconnected, please reschedule for a future time!"
